<template>
  <div>
  <h3 class="content-block openware-form-title">{{ title }}</h3>

  <DxDataGrid
      ref="dataGrid"
      :key-expr="id"
      :data-source="CustomStoreMain"
      :columns="columns"
      :allow-column-reordering="false"
      :allow-column-resizing="false"
      :column-auto-width="true"
      :show-borders="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      :focused-row-enabled="true"
      :word-wrap-enabled="true"
      :selection-filter="['appointments_frequency', '=', '3']"

      :scrolling="{ mode: 'standard', useNative: 'false' }"
      height="auto"

      @exporting="onExporting"
      @selectionChanged="onSelectionChanged"
      @init-new-row="onCustomInitNewRow"
      @initialized="onGridInitialized"
  >

      <DxPaging 
          :enabled="true"
          :page-size="5"
      />

      <DxFilterRow :visible="true"/>

      <DxHeaderFilter :visible="true" :allowHeaderFiltering="false"/>

      <DxPager
          :visible="true"
          :allowed-page-sizes="pageSizes"
          :display-mode="displayMode"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
      />

      <DxSorting mode="multiple"/>

      <DxToolbar>
        <DxItem locate-in-menu="auto" location="before">
                <div class ="ow-list-filters" style="display: flex;">
                    <div class="ow-list-filter">
                        <label class="filter-label" for="selectDateRangeBox">Περίοδος Εργασίας:</label>
                        <DxDateRangeBox
                            ref="selectDateRangeBoxRef"
                            id="selectDateRangeBox"
                            :show-clear-button="true"
                            start-date-label="Από"
                            end-date-label="Εώς"
                            label-mode="static"
                            :multi-view="false"
                            @initialized="onInitializedDateRangeBox"
                            @value-changed="onValueChangedDateRangeBox"
                        />
                    </div>
                    <div class="ow-list-filter">
                        <label class="filter-label" for="selectBoxTechnician">Τεχνικός:</label>
                        <DxSelectBox
                            ref="selectBoxTechnicianRef"
                            id="selectBoxTechnician"
                            :data-source="LookupCustomDS_ow_view_technicians"
                            value-expr="id"
                            display-expr="name"
                            :show-clear-button="true"
                            :search-enabled="false"
                            @initialized="onInitializedTechnician"
                            @value-changed="onValueChangedTechnician"
                        />
                    </div>
                </div>
            </DxItem>

            <DxItem location="after">
                <DxDateBox 
                    placeholder="Ημερομηνία"
                    :show-clear-button="true"
                    :use-mask-behavior="true"
                />
            </DxItem>

            <DxItem location="after" 
                        widget="dxButton" 
                        :options="{
                            icon: 'add',
                            text: '',
                            hint: 'Προσθήκη',
                            onClick: () => {
                                onCustomInitNewRow()
                            }
                        }"
            />

            <DxItem name="exportButton" 
                :options="{
                        hint: 'Εξαγωγή δεδομένων'
                    }"
            />
      </DxToolbar>

      <DxColumn
          data-field="summary_date"
          caption="Ώρα"
          sort-order="asc"
          width="90"
          :hiding-priority="-1"
          :dataType="'date'"
          :format="{  type: 'datetime',
                      formatter: (value) => value.toLocaleString('el-GR', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: false
                      })
                    }"
      >
      </DxColumn>

      <DxColumn
          data-field="technician_id"
          caption="Τεχνικός"
          :hiding-priority="-1"
      >
          <DxLookup
                :data-source="CustomStoreLookup_ow_users"
                value-expr="id"
                display-expr="name"
          />
      </DxColumn>

      <DxColumn
          data-field="  "
          caption="Εισπράξεις"
          data-type="number"
          width="120"
          :format="formatCurrency"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxColumn
          data-field="sum_daily_expenses"
          caption="Έξοδα"
          data-type="number"
          width="120"
          :format="formatCurrency"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxColumn
          data-field="sum_cash_delivery"
          caption="Παραδοση Ταμείου"
          data-type="number"
          width="120"
          :format="formatCurrency"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxColumn
          data-field="net_balance"
          caption="Υπόλοιπο"
          data-type="number"
          width="120"
          :format="formatCurrency"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxSummary>
          <DxTotalItem
              column="sum_collected_amount"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
          />
            <DxTotalItem
              column="sum_daily_expenses"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
          />
          <DxTotalItem
              column="sum_cash_delivery"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
          />
          <DxTotalItem
              column="net_balance"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
          />
      </DxSummary>

      <DxExport
          :enabled="true"
          :formats="['xlsx']"
          :texts= "{
                      exportAll: 'Εξαγωγή σε {0}',
                  }"
      />

  </DxDataGrid>

</div>

</template>

<script setup>
  import {
      DxDataGrid,
      DxColumn,
      //DxEditing, 
      DxPaging, 
      DxPager,
      DxSorting,
      DxFilterRow,
      DxHeaderFilter,
      DxExport,
      DxLookup, 
      //DxRemoteOperations, //DxRequiredRule,
      DxToolbar,
      DxItem,
      DxSummary,
      DxTotalItem,
      //DxGroupItem
  } from 'devextreme-vue/data-grid'

  import 'whatwg-fetch'
  import CustomStore from 'devextreme/data/custom_store'
  
  import { DxDateRangeBox } from 'devextreme-vue/date-range-box';

  import DxSelectBox from 'devextreme-vue/select-box'
  //import { DxCheckBox } from 'devextreme-vue/check-box'
  //import { DxLookup as DxLookupEx, DxDropDownOptions } from 'devextreme-vue/lookup'

  import OParameters from '../es-globals';

  import { ref, /*reactive, computed,*/ onMounted } from 'vue'

  const dataGrid = ref(null)

  const selectedExpenseID = ref(null)
  const selectedYear = ref(new Date().getFullYear())
  const selectedMonth = ref(new Date().getMonth() + 1)
  const selectedDay = ref(new Date().getDate())

  
  const selectBoxTechnicianRef = ref(null)
  const selectedDateRange = ref(null)
  const selectedTechnicianID = ref(null)

  //const confirmedInd = ref(1)

  //const lookupConfirmedRef = ref(null)
  const selectBoxYearRef = ref(null)
  const selectBoxMonthRef = ref(null)
  const selectBoxDayRef = ref(null)

  const title = 'Περιοδική Αναλυτική Αναφορά Ταμείου Ανά Τεχνικό'
  const pageSizes = [5, 10, 20, 0]

  const formatCurrency = { 
                    type: 'currency',
                    currency: 'EUR', 
                    useGrouping: true, 
                    precision: 2 
                }

  const URL_SERVICE = OParameters.Host.URI + 'ow_view_rep_daily_sums'

  //const URL_SERVICE_ow_clients = OParameters.Host.URI + 'ow_clients'
  const URL_SERVICE_ow_users = OParameters.Host.URI + 'ow_users'
  const URL_SERVICE_LOOKUP_ow_view_technicians = OParameters.Host.URI + 'ow_view_technicians';

  const CustomStoreMain = new CustomStore({
        key: 'id',
        // loadMode: 'raw',
        load: () => {
            //const url = `${URL_SERVICE}?filter=summary_date_formatted,eq,${selectedYear.value}-${selectedMonth.value.toString().padStart(2, '0')}-${selectedDay.value.toString().padStart(2, '0')}`;

            if (selectedDateRange.value != null) {
                const betweenQuery = (selectedDateRange.value != null ? `&filter=summary_date,bt,${selectedDateRange.value[0]},${selectedDateRange.value[1]}` : '')
                const url = `${URL_SERVICE}` + '?filter=id,gt,0' +
                            (selectedTechnicianID.value != null ? `&filter=technician_id,eq,${selectedTechnicianID.value}` : '') +
                            betweenQuery
                //console.log(url)
                return sendRequest(url)
            }

        },
        //load: () => sendRequest(URL_SERVICE_ow_view_rep_daily_programme + '?filter=app_date_formatted,eq,' + selectedYear + '-' + selectedMonth.toString().padStart(2, '0') + '-' + selectedDay.toString().padStart(2, '0')),
        insert: (values) => sendRequest(URL_SERVICE, 'POST', values),
        update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
        remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
        byKey: (key) => sendRequest(URL_SERVICE + "/" + encodeURIComponent(key)),
    })

    const CustomStoreLookup_ow_users = new CustomStore({ 
        key: 'id',
        //loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE_ow_users),
        byKey: (key) => sendRequest(URL_SERVICE_ow_users + "/" + encodeURIComponent(key)),
    })

    const LookupCustomDS_ow_view_technicians = new CustomStore({
        key: 'id',
        loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE_LOOKUP_ow_view_technicians + '?order=name'),
        byKey: (key) => sendRequestByKey(URL_SERVICE_LOOKUP_ow_view_technicians + "/" + encodeURIComponent(key)),
    })

    // 
    //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
    //
    const sendRequest = (url, method = 'GET', values = {}) => {
        // console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
        if (method === 'GET') {
            return fetch(url, {
                method,
                credentials: 'include',
            })
            .then(response => {
                return response.json().then(json => {
                    if (response.ok) return json.records;
                    throw json.Message;
                });
            });
        }
        return fetch(url, {
            method,
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            credentials: 'include',
        }).then((result) => {
            if (result.ok) {
                return result.text().then((text) => text && JSON.parse(text));
            }
            return result.json().then((json) => {
                throw json.Message;
            });
        });

    }

    const onExporting = (e) => {
        OParameters.methods.exportDataGridToPdfExcel(e, title)
    }

    const onGridInitialized = () => {
        onInitializedYear()
        onInitializedMonth()
        onInitializedDay()
    }

    const onInitializedYear = () => {
        selectedYear.value = new Date().getFullYear()
        selectBoxYearRef.value?.instance?.option('value', selectedYear.value);
    }

    const onInitializedMonth = () => {
        selectedMonth.value = new Date().getMonth() + 1
        selectBoxMonthRef.value?.instance?.option('value', selectedMonth.value);
    }

    const onInitializedDay = () => {
        selectedDay.value = new Date().getDate()
        selectBoxDayRef.value?.instance?.option('value', selectedDay.value)
    }

    const onSelectionChanged = (e) => {
        selectedExpenseID.value = e.currentSelectedRowKeys[0]
        console.log('selectedExpenseID', selectedExpenseID)
    }

    const onInitializedTechnician = () => {
        selectBoxTechnicianRef.value?.instance?.option('value', selectedTechnicianID.value);
    }

    const onValueChangedTechnician = (e) => {
        selectedTechnicianID.value = e.value
        dataGrid.value?.instance?.refresh()
    }

    const onInitializedDateRangeBox = () => { 
        if (selectedDateRange.value != null) {
            selectDateRangeBoxRef.value?.instance?.option('value', selectedDateRange.value);
        }
    }

    const onValueChangedDateRangeBox = (e) => {
        if (e.value[0] != null && e.value[1] != null) {
        const year1 = e.value[0].getFullYear()
        const month1 = String(e.value[0].getMonth() + 1).padStart(2, '0') // Months are zero-indexed
        const day1 = String(e.value[0].getDate()).padStart(2, '0')
        const year2 = e.value[1].getFullYear()
        const month2 = String(e.value[1].getMonth() + 1).padStart(2, '0') // Months are zero-indexed
        const day2 = String(e.value[1].getDate()).padStart(2, '0')
        selectedDateRange.value = [
            `${year1}-${month1}-${day1}`,
            `${year2}-${month2}-${day2}`
        ]
        dataGrid.value?.instance?.refresh()
        }
    }

    // Lifecycle hooks
    onMounted(() => {
    })

</script>
<style lang="scss">
    .dx-group-cell.dx-last-data-cell {
        font-weight: bold;
    }
</style>
